import { format as i } from "../util.mjs";
var e = "enum", n = function(r, o, t, s, f) {
  r[e] = Array.isArray(r[e]) ? r[e] : [], r[e].indexOf(o) === -1 && s.push(i(f.messages[e], r.fullField, r[e].join(", ")));
};
export {
  n as default
};
//# sourceMappingURL=enum.mjs.map
